
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ButtonSquare.css"
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

function ButtonSquare({ text, icon, onClick, loading, id }) {
    /*id-для идентификации кнопки. Чтобы не все срабатывали*/

    return (
        <>
            <button className="button_square" onClick={() => onClick()} disabled={loading}>
                <div><FontAwesomeIcon icon={loading === true ? faSpinner : icon} className="mr-5 opacity-50" /></div>
                <div>{text}</div>
            </button>
        </>
    )
}

export default ButtonSquare;